import api from '@/api';
import type { CommandPaletteIndexEntry } from '@/utils/commandPaletteIndexDb';

export interface SearchIndexResponse {
  status: 'success' | 'error';
  serverTime?: number;
  full?: boolean;
  items?: CommandPaletteIndexEntry[];
  message?: string;
}

export async function fetchSearchIndex(since?: number): Promise<{
  serverTime: number;
  full: boolean;
  items: CommandPaletteIndexEntry[];
}> {
  const params: Record<string, string | number> = {};
  if (since && since > 0) params.since = since;
  const res = await api.get<SearchIndexResponse>('/search/index', { params });
  if (res.data?.status !== 'success' || !Array.isArray(res.data.items)) {
    return { serverTime: Date.now(), full: true, items: [] };
  }
  return {
    serverTime: res.data.serverTime ?? Date.now(),
    full: res.data.full ?? true,
    items: res.data.items,
  };
}
